import React, { useCallback, useEffect, useState } from "react";
import Header from "../../../Layouts/Components/Header";
import AlertTable from "../alertTable";
import { Grid, Box } from "@mui/material";
import ScreenLoader from "../../shared/ScreenLoader";
import * as yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import {
  getInternalAlerts,
  resetAllAlerts,
  getMessageTypes,
  getTemplates,
  getcurrency,
  updateCriteria,
  createCriteria,
} from "../state/alertActions";
import CriteriaForms from "./CriteriaForms";
import useSnackBar from "../../Hooks/useSnackBar";
import NoItemSelected from "../../shared/NoItemSelected";
import SaveChangesModal from "../../shared/SaveChangesModal";
import { useFormik } from "formik";
import usePrompt from "../../Hooks/usePrompt";
import { useNavigate } from "react-router-dom";

const InternalAlerts = () => {
  const { success, error, snackbar } = useSnackBar();
  const {
    loadingAlerts,
    alertTypes,
    currentCriterial,
    messageTypes,
    Templates,
    Currency,
  } = useSelector((state) => state.internalAlertRules);

  console.log(loadingAlerts);
  const dispatch = useDispatch();
  const loadAlerts = useCallback(
    () => dispatch(getInternalAlerts(true, error)),
    [error, dispatch]
  );
  const loadMessageType = useCallback(
    () => dispatch(getMessageTypes(error)),
    [error, dispatch]
  );
  const loadTemplates = useCallback(
    () => dispatch(getTemplates(error)),
    [error, dispatch]
  );
  const loadCurrency = useCallback(
    () => dispatch(getcurrency(error)),
    [error, dispatch]
  );
  const resetAlerts = useCallback(() => dispatch(resetAllAlerts()), [dispatch]);
  const [touched, setTouched] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [pendingCurrentLicense, setPendingCurrentLicense] = useState(null);
  const Navigate = useNavigate();
  const [pendingLocation, setPendingLocation] = useState(null);

  //navigate to pendingLocation effect
  useEffect(() => {
    if (pendingLocation && !touched) Navigate(pendingLocation);
  }, [Navigate, pendingLocation, touched]);

  const handleBlockedNavigation = useCallback(
    (nextLocation) => {
      if (nextLocation.pathname === "/alerts-settings") return true;
      if (touched) {
        setPendingLocation(nextLocation.pathname);
        setIsConfirmationModalOpen(true);
        return false;
      }
      return true;
    },
    [touched]
  );

  usePrompt(handleBlockedNavigation, touched);

  const validationSchema = yup.object().shape({
    messageType: yup
      .mixed()
      .notOneOf(["select messageType"], "select message type")
      .required("select message type"),
    direction: yup
      .mixed()
      .notOneOf(["select way"], "select  way")
      .required("select way"),
    currency: yup.mixed().when(["alertType"], {
      is: (alertType) => {
        return alertType === "AMOUNT";
      },
      then: yup
        .mixed()
        .notOneOf(["select Currency"], "select  Currency")
        .required("select Currency"),
    }),
    operator: yup
      .mixed()
      .notOneOf(["select Operator"], "select  opertator")
      .required("select opertator"),
    notificationType: yup.string().required("A radio option is required"),
    value: yup.string().required(),
    messageField: yup.mixed().when(["alertType"], {
      is: (alertType) => {
        return alertType === "TEXT";
      },
      then: yup
        .mixed()
        .notOneOf(["select field"], "select  messageField")
        .required("select messageField"),
    }),
    name: yup.string().required(),
    receivers: yup.array().min(1).required().nullable(),
  });

  let test = useCallback(() => {
    let template = "";
    if (currentCriterial?.alertType === "TEXT") {
      template =
        Templates?.Text.filter(
          (temp) => temp.id === currentCriterial?.templateId
        )[0] || Templates?.Text.filter((temp) => temp.isDefault)[0];
    } else {
      template =
        Templates?.Amount.filter(
          (temp) => temp.id === currentCriterial?.templateId
        )[0] || Templates?.Amount.filter((temp) => temp.isDefault)[0];
    }
    return template;
  }, [
    currentCriterial?.templateId,
    Templates?.Amount,
    Templates?.Text,
    currentCriterial?.alertType,
  ]);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      alertType: currentCriterial?.alertType || "",
      messageType: currentCriterial?.messageType || "",
      currency: currentCriterial?.currency || null,
      id: currentCriterial?.id || -1,
      messageField: currentCriterial?.messageField || "",
      direction: currentCriterial?.direction || null,
      operator: currentCriterial?.operator || "",
      value: currentCriterial?.value || "",
      notificationType: currentCriterial?.notificationType || "",
      timeOfDay: currentCriterial?.timeOfDay || null,
      templateId: test() || null,
      receivers: currentCriterial?.receivers || [],
      ccReceivers: currentCriterial?.ccReceivers || [],
      name: currentCriterial?.name || "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const data = {
        id: values?.id,
        name: values.name,
        messageTypeId: values.messageType.id,
        direction: values.direction,
        fieldId: values?.messageField?.id,
        currencyId: values.currency?.id,
        operator: values.operator,
        value: values.value,
        alertType: values.alertType,
        notificationType: values.notificationType,
        timeOfDay: null,
        templateId: values.templateId?.id,
        receivers: values.receivers || [],
        ccReceivers: values.ccReceivers || [],
      };

      if (values?.id === -1) {
        dispatch(createCriteria(data, success, error)).then(() => {
          dispatch(getInternalAlerts(false, error)).then(() => {
            if (pendingCurrentLicense) {
              dispatch({
                type: "CURRENT_CRITERIA",
                payload: pendingCurrentLicense,
              });
            }
          });
        });
      } else {
        dispatch(updateCriteria(data, success, error)).then(() => {
          dispatch(getInternalAlerts(false, error)).then(() => {
            if (pendingCurrentLicense) {
              dispatch({
                type: "CURRENT_CRITERIA",
                payload: pendingCurrentLicense,
              });
            }
          });
        });
      }
      setPendingCurrentLicense(null);
      setIsConfirmationModalOpen(false);
      setTouched(false);
    },
  });

  const handleConfirmSaveChanges = () => {
    formik.handleSubmit();
    setIsConfirmationModalOpen(false);
  };

  const handleDiscardChanges = () => {
    dispatch({ type: "CURRENT_CRITERIA", payload: pendingCurrentLicense });
    setPendingCurrentLicense(null);
    setIsConfirmationModalOpen(false);
    setTouched(false);
  };

  const handleCloseConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setPendingCurrentLicense(null);
  };
  useEffect(() => {
    loadAlerts();
    loadMessageType();
    loadTemplates();
    loadCurrency();
    return () => {
      resetAlerts();
    };
  }, [loadAlerts, resetAlerts, loadMessageType, loadTemplates, loadCurrency]);

  return (
    <>
      {snackbar}
      <SaveChangesModal
        open={isConfirmationModalOpen}
        onClose={handleCloseConfirmationModal}
        discardChanges={handleDiscardChanges}
        saveChanges={handleConfirmSaveChanges}
      />
      <Header headLine="Alerts Settings"></Header>
      {alertTypes && messageTypes && Currency && Templates ? (
        <Grid container columnSpacing={2}>
          <Grid item xs={3}>
            <Box
              sx={{
                background: "#ffffff",
                height: "100vh",
                borderRight: "1px solid #E7E9EF",
              }}
            >
              <AlertTable
                alerts={alertTypes}
                current={currentCriterial}
                touched={touched}
                messageTypes={messageTypes}
                setPendingCurrentLicense={setPendingCurrentLicense}
                setIsConfirmationModalOpen={setIsConfirmationModalOpen}
              />
            </Box>
          </Grid>
          <Grid item xs={9}>
            <Box sx={{ margin: "12px" }}>
              {loadingAlerts ? (
                <ScreenLoader />
              ) : !currentCriterial ? (
                <NoItemSelected />
              ) : (
                <CriteriaForms
                  current={currentCriterial}
                  touched={touched}
                  setTouched={setTouched}
                  formik={formik}
                  Templates={Templates}
                  Currency={Currency}
                  messageTypes={messageTypes}
                  success={success}
                  error={error}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      ) : (
        <ScreenLoader />
      )}
    </>
  );
};

export default InternalAlerts;
